/**
 * Les paramètres d'un entretien, lus comme l'ancien `InterviewScreen` : la catégorie avant le `_`
 * (`motivation` par défaut), « vidéo » après lui, et le rang de l'étape.
 */
export function interviewParams(params: unknown): { category: string; video: boolean; stepNum: number } {
    const read = (params ?? {}) as { testCategory?: unknown; stepNum?: unknown }
    const parts = typeof read.testCategory === "string" ? read.testCategory.split("_") : []
    return {
        category: parts[0] || "motivation",
        video: parts[1] === "video",
        stepNum: Number(read.stepNum),
    }
}
